import * as React from 'react';
import { ActionPlanTopic, assertNever, fieldValidation, SurveyTopic } from '../../../amorg-common';
import { EditableTextArea } from '../../../designSystem/compositeComponents/EditableTextArea';
import { Em } from '../../../designSystem/typography/Em';

export function ActionplanTopicTitle (props: {
    topic: ActionPlanTopic,
    readOnly?: boolean;
    onSaveDescription?: (value: string) => void
}): JSX.Element
{
    if (props.topic.type === 'WPA')
    {
        return <ActionPlanSurveyTopicTitle surveyTopic={props.topic.surveyTopic} />;
    }


    else
    {
        const handleSaveDescription = (value: string) =>
        {
            if (props.onSaveDescription)
                props.onSaveDescription(value);
        };

        return (
            <EditableTextArea
                value={props.topic.description}
                disabled={props.readOnly}
                validator={(currentValue) =>
                {
                    return fieldValidation.actionPlanTopic.description(currentValue)
                        ? { valid: true }
                        : { valid: false, errorMessage: `Ugyldig beskrivelse. Skal udfyldes. Må ikke overstige 200 (${currentValue.length}) tegn.` };
                }}
                onSave={(value, valid) =>
                {
                    if (valid)
                        handleSaveDescription(value);
                }}
                ariaLabel={""}
                hideHoverEditButton
                placeholder={"Indtast emne"} />
        );
    }
}

export function ActionPlanSurveyTopicTitle(props: {
    surveyTopic:SurveyTopic,
}): JSX.Element
{
    const topicTitle = props.surveyTopic.data.title;

    let element = <></>;
    if (props.surveyTopic.linkType === 'theme')
    {
        element = <span>Emnet vedrører temaet <Em>{topicTitle}</Em> fra spørgeskemaet. Temaet indeholder <Em>{props.surveyTopic.questionsInTheme} spørgsmål</Em>.</span>;
    }

    else if (props.surveyTopic.linkType === 'indicator')
    {
        element = <span>Emnet vedrører indikatoren <Em>{topicTitle}</Em> fra spørgeskemaet. Indikatoren er tilknyttet <Em>{props.surveyTopic.questionsWithIndicator} spørgsmål</Em>.</span>;
    }

    else if (props.surveyTopic.linkType === 'question')
    {
        element = <span>Emnet vedrører spørgsmålet <Em>{topicTitle}</Em> fra spørgeskemaet.</span>;
    }

    else
        assertNever(props.surveyTopic);

    return element;
}
